module.exports = __webpack_public_path__ + "img/logo.84efee22.png";